import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { useMemo } from 'react';

type Props = {
  variant?: string;
  title?: string;
  disclaimerData: Array<string>;
  className?: string;
};

const ManualDisclaimer = ({ title, disclaimerData, variant, className = '' }: Props) => {
  const wrappedDisclaimerText = useMemo(() => {
    let disclaimerText = '';
    disclaimerData?.forEach((disclaimerTextItem, index) => {
      disclaimerText += disclaimerTextItem;

      const isLastItem = index === disclaimerData.length - 1;

      if (!isLastItem && !disclaimerTextItem.startsWith('<p>')) {
        disclaimerText += '</br>';
      }
    });
    return {
      value: disclaimerText,
    };
  }, [disclaimerData]);

  const SecondaryVariantContent = () => (
    <div className={className}>
      {title && <h3 className="mb-3">{title}</h3>}
      <RichText tag="div" className="body-default text-grey" field={wrappedDisclaimerText} />
    </div>
  );

  const DefaultVariantContent = () => (
    <div className={`py-4 px-2 px-md-3 px-lg-5 background-digital-light-grey ${className}`}>
      <RichText tag="div" className="footnote" field={wrappedDisclaimerText} />
    </div>
  );

  return <>{variant === 'secondary' ? <SecondaryVariantContent /> : <DefaultVariantContent />}</>;
};

export default ManualDisclaimer;
